module.exports = __webpack_public_path__ + "static/media/LOADER_08.5cd93728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_08.png
// module id = 316
// module chunks = 0